import { Category, Item, ItemGroup, OrderItem, Store } from 'aigens-ng-core';
import { MenuService } from '../../core/services/menu.service';
import { AfterViewInit, Component, Injector, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { IonContent, IonFab, IonVirtualScroll } from '@ionic/angular';
import { RouteTable } from '../../core/route-table';
import { BaseCategoryListPage } from '../../core/base/base-category-list-page';
import { MultiStepComboPage } from 'src/app/routes/item/multi-step-combo/multi-step-combo-page.component';
import { getSetLayout } from '../../shared/utilities/layout-helper';
import { ComboPage } from 'src/app/routes/item/combo-page/combo-page';

/**
 * Generated class for the VirtualScrollPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

// TODO: implements the virtual scroll


@Component({
    selector: 'page-category-item-list',
    templateUrl: 'category-item-list.html',
    styleUrls: ['category-item-list.scss']
})
export class CategoryItemListPage extends BaseCategoryListPage implements OnInit, OnDestroy, AfterViewInit {


    isBounce = false;
    categories: Category[] = [];
    items: Item[] = [];
    rcats: Category[] = [];
    itemHeight = 100;
    headerHeight = 32;
    isfabOpen = false;
    @ViewChild('fab') fab: IonFab;
    @ViewChild(IonContent) list: IonContent;
    // TODO: implement virtualscroll
    @ViewChild('list') vscroll: IonVirtualScroll;

    /* 2017-08-16 - add this to class body
    start FIX#9660 ion-img doesn't correctly work with virtualScroll
    https://github.com/ionic-team/ionic/issues/9660#issuecomment-304840427
    */
    @ViewChild(IonContent) _content: IonContent;

    constructor(public injector: Injector, public menuService: MenuService) {
        super(injector);
        // const session = this.getNavParams('sessionId');
        // if (session) {
        //     this.orderService.session = session;
        // }
        //
        // // TODO: set mode before constructor

    }

    static getPageUrl() {
        return 'category-item-list';
    }

    ionViewWillEnter() {

        if (!this.store && this.storeId) {
            this.getStore(this.orderManager.mode);
        }
    }

    ngOnInit() {
        console.log('ngOnInit VirtualScrollPage');
        super.ngOnInit();
        // this.menuController.swipeEnable(false, 'menu1');
        setTimeout(() => {
            const cIndex = this.getNavParams('categoryIndex');
            let ctop;

            if (cIndex) {
                ctop = this.categories[cIndex]['ctop'];
                this.scrollTo(ctop);

            }
        }, this.platform.is('ios') ? 200 : 700);
        // this.getMenu();
    }

    getStore(type?: string): void {

        this.loading(true);

        this.menuService.getStore(this.storeId, true, type).subscribe(
            store => {
                this.store = store;
                console.log(this.store);
                this.orderService.isBK = store.brand.id === 800001;
                this.setTheme(store.brand, store);
                if (this.orderService.isBK) {
                    const [stopped, period] = this.stoppedPreOrder(store);
                    if (period) {
                        this.saveWeekDay(period);
                    }
                    this.monitoringService.listenStoreKioskStatus(store, () => {
                        this.loading(false);
                        this.showAlert('', this.t.instant('global.kiosk-offline-message'), [{
                            text: this.t.instant('buttons.ok'),
                            handler: () => {
                                this.popToRoot();

                            }
                        }]);
                    }, () => {
                        this.showStore(store);
                    });

                } else {
                    this.showStore(store);

                }
            },
            err => console.error(err),
            () => {
                this.loading(false);
            }
        );

    }


    triggerFab() {
        this.googleAnalyticEventTrack('menu');
        this.isfabOpen = !this.isfabOpen;
        if (!this.isfabOpen) {
            this.googleAnalyticEventTrack('close menu', 'open menu');
        }
    }

    flatten(categories: Category[]) {

        const items = [];

        const headerHeight = this.headerHeight;
        const itemHeight = this.itemHeight;

        let i = 0;
        let y = 0;
        const filter: (Item) => boolean = (item) => this.isPublish(item);
        for (const cat of categories) {
            const mainItems = ItemGroup.getPublishedItemsWithMap(cat.id, cat.groups[0], 0, filter); // cat.groups[0].items;

            const top = i * headerHeight + y * itemHeight;

            cat['ctop'] = top;

            if (mainItems && mainItems.length > 0) {
                mainItems[0]['cindex'] = i;
                items.push(...mainItems);
                y += mainItems.length;
            }

            i++;
        }


        this.categories = categories;
        console.log('item 数据赋予', items);
        this.items = items;
        console.log('item 数据赋予后', this.items);
        this.rcats = categories.slice();

    }

    getHeader = (record, recordIndex, records) => {

        // console.log("header??", record['catIndex'], record, recordIndex);

        const catIndex = record['cindex'];

        if (catIndex != null) {
            // console.log("catIndex", this, this.categories, catIndex);
            const cat = this.categories[catIndex];

            return cat;
        }
        return null;
    }

    catClicked(fab: IonFab, cat: Category) {

        // console.log(this.list);
        console.log(cat);
        // this._content.scrollToTop(100);
        // to do
        // this.googleAnalyticEventTrack("click-category",cat.name);
        const ctop = cat['ctop'];
        if (this.isfabOpen) {
            this.googleAnalyticEventTrack('choose cate', 'open menu');
        }
        if (ctop != null) {
            this.scrollTo(ctop);
        }
        this.isfabOpen = false;
        fab.close();
    }

    scrollTo(top: number) {

        const divs = document.getElementsByClassName('scroll-content');

        const div = divs[divs.length - 1];

        // div.scrollTop = top;
        // TODO: implement virtualscroll
        // this.list.scrollTo(0, top, 0);

        // if(jsDiv){
        //     jsDiv[jsDiv.length - 1].scrollTop = top;
        // }

        const ev: any = {};
        ev.scrollTop = top;

        // TODO: implement virtualscroll
        // this.vscroll.scrollUpdate(ev);
        // this.vscroll.writeUpdate(true);
        // this.vscroll.resize();

    }

    bkCategoryFilter(cats: Category[]): Category[] {
        let tmp;
        tmp = cats.filter((cat) => {
            if (!cat.users || cat.users.length === 0) {
                return true;
            } else {
                const tmpSet = new Set(cat.users);
                if (tmpSet.has('staff')) {
                    console.log('cat name:', cat.name);
                }
                return !tmpSet.has('staff');
            }
        });

        return tmp;
    }

    showStore(store: Store) {

        // var cats = store.menu.getAvailableCategories(store.brand);
        let now = this.convertNowDateToStoreTimeZone(store.timezone).getTime();
        let cats = this.menuManager.getAvailableCategories(store, now, this.orderManager.isTakeout());
        if (this.orderService.isBK) {
            cats = this.bkCategoryFilter(cats);
        }
        if (!cats) {
            return;
        }
        if (cats.length <= 0 && this.orderService.isBK) {
            this.showAlert('This session for ordering has been passed, please wait and retry later.', '', [{
                text: this.t.instant('buttons.ok'),
                handler: () => {

                    this.navigationService.popPage();

                }
            }]);
            return;
        }
        this.categories = cats;
        this.flatten(this.categories);

        this.orderManager.store = store;

    }

    isSet(item: Item) {

        const category = this.getCategory(item);
        return this.isSetItem(item, category);
    }


    addItem(item: Item): OrderItem {

        const category = this.getCategory(item);
        // this.orderService.addSingleItem(this.category, this.groups[0], item);
        const oi = this.orderManager.addSingleItem(category, category.groups[0], item, false);
        this.orderManager.getQuantity(item);
        // TODO: implement virtualscroll
        // this.vscroll.writeUpdate(true);
        return oi;

    }

    minusItem(item: Item) {
        this.orderManager.minusItem(item, true);
        // TODO: implement virtualscroll
        // this.vscroll.writeUpdate(true);

    }

    getCategory(item: Item): Category {
        for (const cat of this.categories) {
            const mainItems = cat.groups[0].items;
            // console.log("mainItems", mainItems.length);
            if (mainItems.indexOf(item) !== -1) {

                return cat;
            }
        }
    }

    addClicked(item: Item) {
        console.log('add clicked');
        // console.log(item);
        // to do
        // this.googleAnalyticEventTrack("click-item",item.name);

        if (this.checkStoreMaxItem(this.storeId)) {
            this.showStoreMaxItemAlert();
            return;
        }

        if (this.isSoldout(item)) {
            return;
        }

        if (this.isSet(item)) {

            const category = this.getCategory(item);
            let params = { store: this.store, category, groups: category.groups, item };
            let page = getSetLayout(this.store.menu.setLayout);
            this.navToAssignLayoutItems(page === 'MultiStepComboPage' ? MultiStepComboPage : ComboPage, page, params);
            // this.pushByName(page, {
            //     store: this.store,
            //     category: category,
            //     groups: category.groups,
            //     item: item
            // }, {relativeTo: this.route});
        } else {
            // const oi = this.addItem(item);
            // const cb = (confirm: boolean) => {
            //     if (!confirm) {
            //         this.minusItem(item);
            //
            //     }
            // };
            if (this.isModifiable(item) && !this.store.menu.quickSingleItem) {
                let cate = this.getCategory(item);
                let oi = this.orderManager.createOrderItem(cate, cate.groups[0], item);
                this.pushByName('ModifierItemSelectPage', {
                    store: this.store,
                    orderitem: oi,
                }, { relativeTo: this.route, skipLocationChange: false });
            } else {
                const oi = this.addItem(item);
            }

            // this.push(CartPage);
        }
        this.bounce();
    }

    cartClicked() {
        if (this.isfabOpen) {
            this.googleAnalyticEventTrack('shopping cart', 'open menu');
        }
        super.cartClicked();
    }


    backButtonClick() {
        this.googleAnalyticEventTrack('back');
        if (this.isfabOpen) {
            this.googleAnalyticEventTrack('back', 'open menu');
        }

        let needAlert = true;
        const catLayout = this.store.menu.settings.catLayout;
        // need a flag
        if (catLayout) {
            needAlert = catLayout === 'showAll';

        }
        if (!this.multOrderManager.enableMutlOrder && needAlert) {

            const alert = this.alertController.create({
                header: this.t.instant('pages.brand-store-list.alert-title'),
                buttons: [
                    {
                        text: this.t.instant('buttons.cancel'),
                        handler: () => {
                            // to do
                            // this.googleAnalyticEventTrack('back-button-event', 'cancel');

                        }
                    },
                    {
                        text: this.t.instant('buttons.leave'),
                        handler: () => {
                            // to do
                            // this.googleAnalyticEventTrack('back-button-event', 'back');
                            super.backButtonClick();
                        }
                    }
                ]
            });

            alert.then(data => data.present());
        } else {
            super.backButtonClick();
        }

    }

    ngOnDestroy() {
        let needClear = true;
        const catLayout = this.store.menu.settings.catLayout;
        // need a flag
        if (catLayout) {
            needClear = catLayout === 'showAll';

        }
        if (!this.multOrderManager.enableMutlOrder && needClear) {
            this.orderManager.clear();
        }

    }

    ionViewWillLeave() {
        this.fab.close();
        this.isfabOpen = false;
    }

    tapSearch() {
        this.pushByUrl(RouteTable['SearchItemPage'], {
            categories: this.categories,
            store: this.store,
            storeId: this.storeId
        }, { relativeTo: this.route });
    }

    ngAfterViewInit() {
        return null;
        // TODO: implement content
        // if (this._content) {
        //     this._content.imgsUpdate = () => {
        //         if (this._content._scroll.initialized && this._content._imgs.length && this._content.isImgsUpdatable()) {
        //             // reset cached bounds
        //             this._content._imgs.forEach((img: IonImg) => (<any>img)._rect = null);
        //             // use global position to calculate if an img is in the viewable area
        //             updateImgs(this._content._imgs, this._content._cTop * -1, this._content.contentHeight, this._content.directionY, 1400, 400);
        //         }
        //     };
        // }
    }

    /*
    end FIX#9660
    */

    public pageName(): string {
        return '/category-item-list';
    }
}
